import { Supplier } from 'dtos/catalog/supplier.dto';
import { PaginatedResponse, toPaginatedResponse } from 'dtos/common/api.dto';
import { apiClient } from 'services/api-client';

export class SupplierService {
  static async list(orgId: string, page = 1, pageSize = 8): Promise<PaginatedResponse<Supplier>> {
    const response = await apiClient.get<Supplier[]>(`/orgs/${orgId}/suppliers?page=${page}&pageSize=${pageSize}`);
    return toPaginatedResponse(response, page, pageSize);
  }

  static async get(orgId: string, supplierId: string): Promise<Supplier | null> {
    const suppliers = await this.list(orgId, 1, 1000);
    return suppliers.data.find(supplier => supplier.id === supplierId) ?? null;
  }
}

